var map = {
	"./template.bet575": 1671,
	"./template.bet575.tsx": 1671,
	"./template.bet777": 1672,
	"./template.bet777.tsx": 1672,
	"./template.betbetbet": 1673,
	"./template.betbetbet.tsx": 1673,
	"./template.betstride": 1674,
	"./template.betstride.tsx": 1674,
	"./template.buffalobet": 1675,
	"./template.buffalobet.tsx": 1675,
	"./template.default": 85,
	"./template.default.tsx": 85,
	"./template.epicodds": 1676,
	"./template.epicodds.tsx": 1676,
	"./template.fiestabet": 1677,
	"./template.fiestabet.tsx": 1677,
	"./template.forsport": 1678,
	"./template.forsport.tsx": 1678,
	"./template.gigabet": 1679,
	"./template.gigabet.tsx": 1679,
	"./template.goldenbet888": 1989,
	"./template.goldenbet888.tsx": 1989,
	"./template.goldenrush": 1680,
	"./template.goldenrush.tsx": 1680,
	"./template.hyperbet": 1681,
	"./template.hyperbet.tsx": 1681,
	"./template.juicybet": 1682,
	"./template.juicybet.tsx": 1682,
	"./template.magnumbet": 1683,
	"./template.magnumbet.tsx": 1683,
	"./template.oldgill": 1684,
	"./template.oldgill.tsx": 1684,
	"./template.puntcity": 1685,
	"./template.puntcity.tsx": 1685,
	"./template.pyramidbet": 1686,
	"./template.pyramidbet.tsx": 1686,
	"./template.slambet": 1687,
	"./template.slambet.tsx": 1687,
	"./template.sterlingparker": 1688,
	"./template.sterlingparker.tsx": 1688,
	"./template.sugarcastle": 1689,
	"./template.sugarcastle.tsx": 1689,
	"./template.templebet": 1690,
	"./template.templebet.tsx": 1690,
	"./template.titanbet": 1691,
	"./template.titanbet.tsx": 1691,
	"./template.ts": 817
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2471;